<template>
  <l-layout :layout="['xs12']">
    <v-form ref="deviceForm">
      <v-card class="pa-3">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field
                v-model="form.name"
                prepend-icon="$vuetify.icons.title"
                label="控制器名称"
                :disabled="disabledFlag"
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-btn
                flat
                color="primary"
                @click="updateDialog.activated = true"
                :loading="updateDialog.loading"
                >在线更新</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="methodDialog.activated = true"
                :loading="methodDialog.loading"
                >指令下发</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <l-autocomplete
                :get-data="getGateByName"
                item-text="name"
                label="关联卡口选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.gate"
                disabled
                v-if="!disabledFlag"
              ></l-autocomplete>
              <v-select
                :items="form.gateSelect"
                item-text="name"
                v-model="form.gate"
                label="关联卡口选择"
                chips
                prepend-icon="$vuetify.icons.parkingLot"
                v-else
                disabled
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea
                label="控制器描述"
                prepend-icon="$vuetify.icons.comment"
                rows="1"
                auto-grow
                :disabled="disabledFlag"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs2>
              <v-text-field
                label="显示屏显示行数"
                prepend-icon="$vuetify.icons.code"
                v-model="form.ledRows"
                :disabled="disabledFlag"
              ></v-text-field>
            </v-flex>
            <v-flex xs10>
              <v-text-field
                label="显示屏显示内容"
                prepend-icon="$vuetify.icons.audio"
                v-model="form.ledDatas"
                :disabled="disabledFlag"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <l-data-table
            :get-data-func="getDeviceHeartBeat"
            :title-text="'设备心跳属性'"
            :headers="devicePropertyHeader"
            hide-title-actions
            hide-title-search
          ></l-data-table>
          <v-layout justify-center>
            <v-btn flat color="primary" @click="addSubDevice"
              >添加虚拟控制器</v-btn
            >
          </v-layout>
          <l-data-table
            title-text="虚拟设备列表"
            :headers="header"
            :get-data-func="getSubDeviceList"
            flat
            clickable
            @click:row="getSubDeviceDetails($event.item)"
            hide-title-search
            ref="subDeviceList"
          >
            <template slot="row-action" slot-scope="{ item }">
              <td @click.stop class="px-0 mx-0 text-xs-center">
                <v-tooltip left>
                  <v-btn
                    @click="deleteSubDeviceConfirm(item)"
                    slot="activator"
                    icon
                  >
                    <v-icon small>$vuetify.icons.delete</v-icon>
                  </v-btn>
                  <span>删除删除控制器</span>
                </v-tooltip>
              </td>
            </template>
          </l-data-table>
          <l-data-table
            title-text="控制器远程操作历史"
            :headers="operationHeader"
            :get-data-func="getControllerHistory"
            hide-title-search
          ></l-data-table>
          <v-dialog width="900px" v-model="subDeviceDialog.activate">
            <v-layout column>
              <v-form ref="subDeviceForm">
                <v-card class="mt-3 pa-3">
                  <v-card-title class="mb-2">
                    <h3>虚拟设备详情</h3>
                  </v-card-title>
                  <v-layout column class="mt-2">
                    <v-layout>
                      <v-flex xs6>
                        <v-text-field
                          label="控制器名称"
                          prepend-icon="$vuetify.icons.title"
                          v-model="curSubDevice.name"
                          :disabled="subDeviceDialog.type === 'read'"
                          :rules="[$rules.requiredS()]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6>
                        <v-select
                          label="控制类型"
                          prepend-icon="$vuetify.icons.location"
                          :items="curSubDevice.typeSelect"
                          :rules="[$rules.requiredS()]"
                          v-model="curSubDevice.ctrlType"
                          :disabled="subDeviceDialog.type === 'read'"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                          label="关联卡口"
                          prepend-icon="$vuetify.icons.parkingLot"
                          :items="form.dirGateList"
                          v-model="curSubDevice.gate"
                          :disabled="subDeviceDialog.type === 'read'"
                          :rules="[$rules.requiredS()]"
                          item-text="name"
                          item-value="id"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs6>
                        <v-radio-group
                          mandatory
                          row
                          v-model="curSubDevice.pictureUp"
                          label="是否允许上传图片"
                          prepend-icon="$vuetify.icons.lock"
                          :disabled="subDeviceDialog.type === 'read'"
                        >
                          <v-radio :value="true" label="允许"></v-radio>
                          <v-radio :value="false" label="不允许"></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs2>
                        <v-text-field
                          label="显示屏显示行数"
                          prepend-icon="$vuetify.icons.code"
                          v-model="curSubDevice.ledRows"
                          :disabled="subDeviceDialog.type === 'read'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs10>
                        <v-text-field
                          label="显示屏显示内容"
                          prepend-icon="$vuetify.icons.audio"
                          v-model="curSubDevice.ledDatas"
                          :disabled="subDeviceDialog.type === 'read'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout column>
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field
                            label="摄像头驱动"
                            prepend-icon="$vuetify.icons.audio"
                            v-model="curSubDevice.cameraDriver"
                            :disabled="subDeviceDialog.type === 'read'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-btn
                            flat
                            color="primary"
                            :disabled="subDeviceDialog.type === 'read'"
                            @click="addCameraIp()"
                            >添加CameraIp</v-btn
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout
                        v-for="(c, index) in curSubDevice.cameraIp"
                        :key="index"
                      >
                        <v-flex xs5>
                          <v-text-field
                            label="ip"
                            v-model="c.ip"
                            prepend-icon="$vuetify.icons.code"
                            :disabled="subDeviceDialog.type === 'read'"
                            :rules="[$rules.requiredS()]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-select
                            label="type"
                            :items="c.typeSelect"
                            v-model="c.type"
                            prepend-icon="$vuetify.icons.code"
                            :disabled="subDeviceDialog.type === 'read'"
                            :rules="[$rules.requiredS()]"
                          ></v-select>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn
                            flat
                            color="error"
                            @click="deleteCameraIp(index)"
                            :disabled="subDeviceDialog.type === 'read'"
                            >删除</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-layout>
                  <l-data-table
                    v-if="subDeviceDialog.type === 'read'"
                    :get-data-func="getSubDeviceHeartBeat"
                    :title-text="'虚拟设备心跳属性'"
                    :headers="devicePropertyHeader"
                    hide-title-actions
                    hide-title-search
                  ></l-data-table>
                  <l-data-table
                    title-text="虚拟控制器操作历史"
                    :headers="operationHeader"
                    :get-data-func="getSubControllerHistory"
                    ref="subControllerHistoryTable"
                    hide-title-search
                  ></l-data-table>
                  <v-layout justify-center>
                    <v-btn
                      class="primary"
                      v-if="subDeviceDialog.type === 'new'"
                      @click="addSubDeviceSubmit"
                      :loading="loading"
                      >确定</v-btn
                    >
                    <v-btn
                      class="error"
                      @click="
                        subDeviceDialog = { activate: false, type: 'read' }
                      "
                      v-if="subDeviceDialog.type === 'new'"
                      >取消</v-btn
                    >
                    <v-btn
                      class="error"
                      @click="
                        subDeviceDialog = { activate: false, type: 'read' }
                      "
                      v-if="subDeviceDialog.type === 'read'"
                      >关闭</v-btn
                    >
                  </v-layout>
                </v-card>
              </v-form>
            </v-layout>
          </v-dialog>
        </v-layout>
        <v-layout justify-center v-if="showUpdateBtn">
          <v-btn
            class="primary"
            @click="disabledFlag = false"
            v-if="disabledFlag"
            >修改</v-btn
          >
          <v-btn
            class="primary"
            @click="submit"
            :loading="loading"
            :disabled="disabledFlag"
            v-if="!disabledFlag"
            >提交</v-btn
          >
        </v-layout>
        <v-dialog width="800" v-model="updateDialog.activated">
          <v-layout column>
            <v-card class="pa-2">
              <v-card-title>
                <h3>程序包选择</h3>
              </v-card-title>
              <v-layout column>
                <l-autocomplete
                  :get-data="getPackageByName"
                  item-text="name"
                  label="关联卡口选择"
                  prepend-icon="$vuetify.icons.folder"
                  v-model="updateDialog.package"
                ></l-autocomplete>
              </v-layout>
              <v-layout justify-center>
                <v-btn class="primary" @click="updateController">确定</v-btn>
                <v-btn class="error" @click="updateDialog.activated = false"
                  >取消</v-btn
                >
              </v-layout>
            </v-card>
          </v-layout>
        </v-dialog>
        <v-dialog width="800" v-model="methodDialog.activated">
          <v-layout column>
            <v-card class="pa-2">
              <v-card-title>
                <h3>指令选择</h3>
              </v-card-title>
              <v-layout column>
                <v-select
                  :items="methodList"
                  label="下发指令"
                  prepend-icon="$vuetify.icons.code"
                  v-model="methodDialog.method"
                  item-text="label"
                  item-value="key"
                ></v-select>
              </v-layout>
              <v-layout justify-center>
                <v-btn class="primary" @click="sendMessage">确定</v-btn>
                <v-btn class="error" @click="methodDialog.activated = false"
                  >取消</v-btn
                >
              </v-layout>
            </v-card>
          </v-layout>
        </v-dialog>
      </v-card>
    </v-form>
  </l-layout>
</template>

<script>
import { time } from "../../../ladmin/utils/time";
import {PERMISSION} from '@/consts/userAdmin'

export default {
  name: "deviceDetail",
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    testVal: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      updateDialog: {
        activated: false,
        package: "",
        loading: false,
      },
      methodDialog: {
        activated: false,
        method: "",
        loading: false,
      },
      methodList: [
        { key: "DEVICESRV_REBOOT", label: "系统重启" },
        { key: "DEVICESRV_LOG_PULL", label: "日志拉取" },
      ],
      disabledFlag: true,
      loading: false,
      subDeviceDialog: {
        type: "read",
        activate: false,
      },
      operationHeader: [
        {
          text: "方法名称",
          value: "method",
          sortable: false,
          align: "left",
          maxWidth: "18em",
          tooltip: true,
        },
        {
          text: "请求数据",
          value: "reqData",
          sortable: false,
          align: "left",
          maxWidth: "18em",
          tooltip: true,
        },
        {
          text: "返回数据",
          value: "resData",
          sortable: false,
          align: "left",
          maxWidth: "18em",
          tooltip: true,
        },
        {
          text: "扩展值",
          value: "extend",
          sortable: false,
          align: "left",
          maxWidth: "18em",
          tooltip: true,
        },
        {
          text: "操作时间",
          value: "creationTime",
          sortable: true,
          align: "left",
          f: (v) => time.stringify(v),
        },
      ],
      header: [
        { text: "设备名称", value: "name", sortable: false, align: "left" },
        { text: "设备序列号", value: "sn", sortable: true, align: "left" },
        {
          text: "设备登录时间",
          value: "signTime",
          sortable: true,
          align: "left",
          f: (v) => time.stringify(v),
        },
        {
          text: "上次心跳时间",
          value: "lastHeartBeatTime",
          sortable: true,
          align: "left",
          f: (v) => time.stringify(v),
        },
        { text: "", value: "", sortable: false, align: "left`" },
      ],
      devicePropertyHeader: [
        {
          text: "心跳状态",
          value: "status",
          sortable: false,
          align: "left",
          f: (v) => (v === "1" ? "在线" : "掉线"),
        },
        {
          text: "上次心跳时间",
          value: "creationTime",
          sortable: true,
          align: "left",
        },
        {
          text: "CPU利用率",
          value: "cpuUtilization",
          sortable: false,
          align: "left",
        },
        {
          text: "CPU温度",
          value: "cpuUtilization",
          sortable: false,
          align: "left",
        },
        {
          text: "内存总量",
          value: "totalMemorySize",
          sortable: false,
          align: "left",
        },
        {
          text: "内存剩余量",
          value: "remainingMemorySize",
          sortable: false,
          align: "left",
        },
        {
          text: "磁盘总量",
          value: "totalDiskSize",
          sortable: false,
          align: "left",
        },
        {
          text: "磁盘剩余量",
          value: "remainingDiskSize",
          sortable: false,
          align: "left",
        },
      ],
      curSubDevice: {},
      form: {
        name: "",
        description: "",
        sn: "",
        gate: "",
        gateSelect: [],
        service: "",
        dirGateList: [],
        ledRows: "2",
        ledDatas: "欢迎光临|旅途愉快",
        heartInfo: [],
        heartCreationTime: "",
        heartStatus: "",
        status: "",
      },
    };
  },
  computed: {
    showUpdateBtn () {
      return this.$store.getters['login/hasPermissionOf'](PERMISSION.PARK.CONTROLLER.UPDATE)
    }
  },
  created() {
    this.init();
  },
  methods: {
    changeProps() {
      this.testVal = "2";
    },
    init() {
      if (this.formData === {}) {
        return;
      }
      this.form.name = this.formData.name;
      this.form.sn = this.formData.sn;
      this.form.description = this.formData.description;
      this.form.status = this.formData.status;
      let extend = JSON.parse(this.formData.extend);
      this.form.ledRows = extend.ledRows;
      this.form.ledDatas = extend.ledDatas;
      this.getGateBySn(this.form.sn);
      /*        this.getDeviceHeartBeat(this.form.sn)*/
    },
    async getGateBySn(id) {
      try {
        let { items } = await this.$store.dispatch(
          "park/getUnDirControllerList",
          {
            pagination: { page: 1, rowsPerPage: 100 },
            search: { key: "deviceSn", value: id },
          }
        );
        if (items.length === 0) {
          this.$L.alert("error", { message: "未查询到关联卡口" });
        } else {
          this.form.gate = items[0];
          this.form.gateSelect = [];
          this.form.gateSelect.push(items[0]);
        }
      } catch (e) {
        this.$L.alert("error", { message: e.message });
        return [];
      }
    },
    async getGateByName(val) {
      try {
        let { items } = await this.$store.dispatch(
          "park/getUnDirControllerList",
          {
            pagination: { page: 1, rowsPerPage: 100 },
            search: { key: "name", value: val },
          }
        );
        return items;
      } catch (e) {
        this.$L.alert("error", { message: e.message });
        return [];
      }
    },
    async getPackageByName(val) {
      try {
        let { items } = await this.$store.dispatch("iot/getPackageList", {
          pagination: { page: 1, rowsPerPage: 100 },
          search: { key: "name", value: val },
        });
        return items;
      } catch (e) {
        this.$L.alert("error", { message: e.message });
        return [];
      }
    },
    addSubDevice() {
      this.curSubDevice = {
        name: "",
        description: "",
        gate: "",
        pictureUp: true,
        sn: "",
        ledRows: "2",
        ledDatas: "欢迎光临|旅途愉快",
        cameraDriver: "",
        ctrlType: "",
        typeSelect: ["in", "out"],
        cameraIp: [],
      };
      this.subDeviceDialog.activate = true;
      this.subDeviceDialog.type = "new";
    },
    async addSubDeviceSubmit() {
      if (this.$refs.subDeviceForm.validate()) {
        let cameraIp = [];
        for (let i = 0; i < this.curSubDevice.cameraIp.length; i++) {
          let obj = {
            ip: this.curSubDevice.cameraIp[i].ip,
            type: this.curSubDevice.cameraIp[i].type,
          };
          cameraIp.push(obj);
        }
        for (let i = 0; i < this.form.dirGateList.length; i++) {
          if (this.curSubDevice.gate === this.form.dirGateList[i].id) {
            this.curSubDevice.sn = this.form.dirGateList[i].entranceId;
          }
        }
        let params = {
          deviceId: this.formData.id,
          subDevice: [
            {
              name: this.curSubDevice.name,
              sn: this.curSubDevice.sn,
              dirgateId: this.curSubDevice.gate,
              pictureUp: this.curSubDevice.pictureUp,
              ledRows: this.curSubDevice.ledRows,
              cameraIp: cameraIp,
              ledDatas: this.curSubDevice.ledDatas,
              ctrlType: this.curSubDevice.ctrlType,
              cameraDriver: this.curSubDevice.cameraDriver,
            },
          ],
        };
        this.loading = true;
        try {
          let res = await this.$store.dispatch("iot/addSubDevice", params);
          if (res.data.status + "" === "200") {
            this.$L.alert("success", { message: "添加成功" });
            this.$refs.subDeviceList.refresh();
            this.subDeviceDialog.activate = false;
            this.subDeviceDialog.type = "read";
          }
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        this.$L.alert("error", { message: "存在不合法数据，无法创建虚拟设备" });
      }
    },
    addCameraIp(index) {
      this.curSubDevice.cameraIp.push({
        ip: "",
        type: "",
        typeSelect: ["in", "out"],
      });
    },
    deleteCameraIp(index) {
      this.curSubDevice.cameraIp.splice(index, 1);
    },
    async submit() {
      if (this.$refs.deviceForm.validate()) {
        let params = {
          id: this.formData.id,
          name: this.form.name,
          description: this.form.description,
          sn: this.form.sn,
          access_protocol: "websocket",
          net_type: "CELLULAR",
          property: [
            {
              name: "memory",
              description: "内存",
              value: "10MB",
            },
            {
              name: "disk",
              description: "磁盘存储",
              value: "100MB",
            },
            {
              name: "temperature",
              description: "温度",
              value: "60℃",
            },
            {
              name: "humidity",
              description: "湿度",
              value: "90%RH",
            },
            {
              name: "semaphore",
              description: "信号量",
              value: "30%",
            },
          ],
          entend: {
            ledRows: this.form.ledRows,
            ledDatas: this.form.ledDatas,
          },
        };
        this.loading = true;
        try {
          let res = await this.$store.dispatch("iot/updateDevice", params);
          if (res.data.status + "" === "200") {
            this.$L.alert("success", { message: "修改成功" });
            this.disabledFlag = true;
          } else {
            this.$L.alert("error", {
              message: "修改失败，原因：" + res.data.msg,
            });
          }
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        this.$L.alert("error", { message: "表单数据不合法" });
      }
    },
    async getSubDeviceList({ pagination }) {
      let { items } = await this.$store.dispatch("iot/getDeviceList", {
        pagination: { page: 1, rowsPerPage: 100 },
        search: { key: "id", value: this.formData.id },
      });
      if (items.length === 0) {
        return { items: [], amount: 0 };
      } else {
        let arr = [];
        for (let i = 0; i < items[0].subDevices.length; i++) {
          arr.push(this.dealSubDeviceData(items[0].subDevices[i]));
        }
        return { items: arr, amount: arr.length };
      }
    },
    dealSubDeviceData(item) {
      console.log(item);
      let extend = JSON.parse(item.extend) || {};
      let info = JSON.parse(item.info) || {};
      let obj = {
        lastHeartBeatTime: item.msgRecord && item.msgRecord.creationTime,
        name: item.name || "",
        sn: item.sn || "",
        pictureUp: info.pictureUp || "",
        ledRows: info.ledRows || "",
        ledDatas: "欢迎光临|旅途愉快" || "",
        cameraDriver: info.cameraDriver || "",
        ctrlType: info.ctrlType || "",
        typeSelect: ["in", "out"],
        signTime: extend.signInTime === undefined ? "N/A" : extend.signInTime,
        cameraIp: [],
        gate: "",
        heartInfo: [],
        heartStatus: "",
        status: item.status,
      };
      for (let i = 0; i < info.cameraIp.length; i++) {
        let c = {
          ip: info.cameraIp[i]["ip"] || "",
          type: info.cameraIp[i]["type"] || "",
          typeSelect: ["in", "out"],
        };
        obj.cameraIp.push(c);
      }
      for (let i = 0; i < this.form.dirGateList.length; i++) {
        let d = this.form.dirGateList[i];
        if (obj.sn === d.subDeviceSn) {
          obj.gate = this.form.dirGateList[i];
        }
      }
      return obj;
    },
    async getControllerHistory({ pagination, sortStack, filterItems, search }) {
      let { items, amount } = await this.$store.dispatch(
        "iot/getControllerOperationHistory",
        {
          pagination,
          search: { key: "sn", value: this.formData.sn },
        }
      );
      return { items: items, amount: amount };
    },
    async getSubControllerHistory({
      pagination,
      sortStack,
      filterItems,
      search,
    }) {
      let { items, amount } = await this.$store.dispatch(
        "iot/getControllerOperationHistory",
        {
          pagination,
          search: { key: "sn", value: this.curSubDevice.sn },
        }
      );
      return { items: items, amount: amount };
    },
    getSubDeviceDetails(item) {
      let selectionString = document.getSelection().toString();
      if (!selectionString) {
        this.curSubDevice = item;
        this.subDeviceDialog.type = "read";
        this.subDeviceDialog.activate = true;
        this.getSubDeviceHeartBeat(this.curSubDevice.sn);
        this.$refs.subControllerHistoryTable.refresh();
      }
    },
    async deleteSubDeviceConfirm(item) {
      let { res, close } = await this.$L.confirm({
        title: "确认删除该虚拟控制器？",
        text: "虚拟控制器名称:" + item.name,
      });
      if (res) {
        try {
          await this.deleteSubDevice(item);
        } catch (e) {
          this.$L.alert("error", e.message);
        }
      }
      close();
    },
    async deleteSubDevice(item) {
      let ids = [];
      ids.push(item.sn);
      let params = {
        deviceId: this.formData.id,
        subDeviceSn: ids,
      };
      let res = await this.$store.dispatch("iot/deleteSubDevice", params);
      if (res.data.status + "" === "200") {
        this.$L.alert("success", { message: "删除成功" });
        this.$refs.subDeviceList.refresh();
      } else {
        this.$L.alert("error", { message: "删除失败，原因：" + res.data.msg });
      }
    },
    async getDeviceHeartBeat() {
      let filter = [
        { key: "sn", value: this.form.sn },
        { key: "method", value: "HEART_BEAT" },
      ];
      let pagination = {
        page: 1,
        rowsPerPage: 10,
      };
      let { items } = await this.$store.dispatch("iot/getDeviceHearBeatList", {
        pagination: { page: 1, rowsPerPage: 10 },
        filter: filter,
      });
      if (items.length === 0) {
        this.$L.alert("error", { message: "未查询到该设备心跳" });
        return { items: [], amount: 0 };
      } else {
        this.form.heartStatus = items[0].extend;
        this.form.heartCreationTime = time.stringify(items[0].creationTime);
        this.form.heartInfo = this.dealHeartInfo(items[0].data);
        let obj = {
          status: this.form.heartStatus,
          creationTime: this.form.heartCreationTime,
        };
        for (let i in this.form.heartInfo) {
          obj[this.form.heartInfo[i].name] = this.form.heartInfo[i].value;
        }
        let arr = [obj];
        return { items: arr, amount: 1 };
      }
    },

    async getSubDeviceHeartBeat() {
      let filter = [
        { key: "sn", value: this.curSubDevice.sn },
        { key: "method", value: "HEART_BEAT" },
      ];
      let pagination = {
        page: 1,
        rowsPerPage: 10,
      };
      let { items } = await this.$store.dispatch("iot/getDeviceHearBeatList", {
        pagination: { page: 1, rowsPerPage: 10 },
        filter: filter,
      });
      if (items.length === 0) {
        this.$L.alert("error", { message: "未查询到该设备心跳" });
        return { items: [], amount: 0 };
      } else {
        this.curSubDevice.heartStatus = items[0].extend;
        this.curSubDevice.heartCreationTime = time.stringify(
          items[0].creationTime
        );
        this.curSubDevice.heartInfo = this.dealHeartInfo(items[0].data);
        let obj = {
          status: this.form.heartStatus,
          creationTime: this.form.heartCreationTime,
        };
        for (let i in this.curSubDevice.heartInfo) {
          obj[
            this.curSubDevice.heartInfo[i].name
          ] = this.curSubDevice.heartInfo[i].value;
        }
        let arr = [obj];
        return { items: arr, amount: 1 };
      }
    },
    dealHeartInfo(data) {
      try {
        let res = JSON.parse(data);
        return res.result.data.state;
      } catch (e) {
        this.$L.alert(e);
      }
    },
    async updateController() {
      try {
        this.methodDialog.loading = true;
        let res = await this.$store.dispatch("iot/updateController", {
          sn: this.form.sn,
          method: this.updateDialog.package.id,
        });
        if (res.data.status + "" === "200") {
          this.alert("success", { message: "更新成功" });
        } else {
          this.$L.alert("error", { message: "更新失败，原因:" + res.data.msg });
        }
      } catch (e) {
        this.$L.alert("error", { message: e });
      } finally {
        this.updateDialog.loading = true;
      }
    },
    async sendMessage() {
      try {
        this.methodDialog.loading = true;
        let res = await this.$store.dispatch("iot/sendMessage", {
          sn: this.form.sn,
          method: this.methodDialog.method,
        });
        if (res.data.status + "" === "200") {
          this.$L.alert("success", { message: "下发成功" });
        } else {
          this.$L.alert("error", { message: "下发失败，原因:" + res.data.msg });
        }
      } catch (e) {
        this.$L.alert("error", { message: e });
      } finally {
        this.methodDialog.loading = true;
      }
    },
  },
  watch: {
    "form.gate"() {
      if (this.form.gate !== null && this.form.gate !== "") {
        this.form.dirGateList = this.form.gate.dirgateList;
        this.$refs.subDeviceList.refresh();
      }
    },
  },
};
</script>

<style scoped>
</style>
